import { render, staticRenderFns } from "./MiniArea.vue?vue&type=template&id=1965b770&"
import script from "./MiniArea.vue?vue&type=script&lang=js&"
export * from "./MiniArea.vue?vue&type=script&lang=js&"
import style0 from "./MiniArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports